<template>
  <div class="component-block user-login-page">
    <div class="spin" v-if="loading">
      <LoadingSpinner />
    </div>
    <div class="block-container">
      <div class="login-container">
        <img class="logo" src="../assets/images/logo.png" alt="logo" />
        <form
          class="login-form"
          @submit.prevent="login"
          name="login-form"
          autocomplete="on"
          method="post"
          id="login-form"
        >
          <h1 class="block-title">Портал перевозчиков</h1>
          <div
            class="floating-label-input email-input"
            :class="{
              'has-value': name,
              'error-input': nameError,
              'error-input-with-margin':
                (nameError || passwordError) &&
                (name.trim() === '' || password === ''),
            }"
          >
            <input
              v-model.trim="name"
              type="text"
              id="email"
              name="username"
              placeholder=" "
              @keydown.space.prevent
              autocomplete="username"
            />
            <label for="email">Имя пользователя</label>
            <div class="error-message" v-if="nameError">{{ nameError }}</div>
          </div>
          <div
            class="floating-label-input"
            :class="{
              'has-value': password,
              'error-input': passwordError,
              'error-input-with-margin':
                (nameError || passwordError) &&
                (name.trim() === '' || password === ''),
            }"
          >
            <input
              v-model.trim="password"
              :type="passwordVisible ? 'text' : 'password'"
              id="password"
              name="password"
              placeholder=" "
              @keydown.space.prevent
              autocomplete="current-password"
            />
            <label for="password">Пароль</label>
            <div class="error-message" v-if="passwordError">
              {{ passwordError }}
            </div>
            <button
              type="button"
              class="password-visibility"
              @click.stop="changePasswordVisibility"
            >
              <ClosedEye v-if="!passwordVisible" />
              <OpenedEye v-else />
            </button>
          </div>
          <div v-if="!isCreateNewPassword" class="form-check remember-me">
            <div class="remember-me-wrapper">
              <input
                v-model="rememberMe"
                class="form-check-input"
                type="checkbox"
                id="rememberMeCheck"
                name="rememberMe"
              />
              <label class="form-check-label" for="rememberMeCheck">
                Запомнить меня
              </label>
            </div>
            <Popper hover placement="bottom">
              <template #content>
                <div class="popup-popper">Забыли пароль</div>
              </template>
              <a
                class="reset-password-link"
                @click.prevent="resetPasswordDialogVisible = true"
              >
                Забыли пароль?
              </a>
            </Popper>
          </div>
          <div class="recaptcha-container">
            <vue-recaptcha
              v-show="true"
              sitekey="6LeAFqYrAAAAAB0BlICFQhfkEHRaNKxFDSETGzVn"
              size="normal"
              theme="light"
              hl="tr"
              :loading-timeout="1000"
              @verify="recaptchaVerified"
              ref="vueRecaptcha"
            >
            </vue-recaptcha>
          </div>

          <button
            v-if="!isCreateNewPassword"
            class="login-btn"
            type="submit"
            name="submit"
            id="submit-login"
          >
            Войти в систему мониторинга
          </button>
        </form>
        <div class="in-touch">
          <div class="in-touch-elem"></div>
          <div class="in-touch-text">GEOSERVICE на связи</div>
          <div class="in-touch-elem"></div>
        </div>
        <div class="login-link_wrapper">
          <a class="login-link" href="https://geosmt.ru/" target="_blank">
            <Planet />
            Cайт компании
          </a>
          <a class="login-link" href="https://t.me/geoservice_docs_bot" target="_blank">
            <Headphone />
            Техническая поддержка
          </a>
        </div>
      </div>

      <div class="image-container" :style="backgroundImageStyle">
        <div class="image-text uppercase">Мониторинг транспорта</div>
      </div>
    </div>
    <ModalView
      v-model:show="resetPasswordDialogVisible"
      :title="'Сбросить пароль'"
    >
      <label
        class="edit-input"
        style="margin-bottom: 0"
        :class="{ 'error-input': resetPasswordEmailError !== '' }"
      >
        <div class="edit-input-label">E-mail пользователя</div>
        <input
          v-model="resetPasswordEmail"
          type="text"
          placeholder="Введите e-mail пользователя"
        />
        <div class="edit-error" v-if="resetPasswordEmailError !== ''">
          {{ resetPasswordEmailError }}
        </div>
      </label>

      <template v-slot:footer>
        <!-- content for the footer slot -->
        <button @click="resetPassword" type="button" class="button-reset">
          Сбросить пароль
        </button>
      </template>
    </ModalView>
  </div>
</template>
<script>
import http from "@/http";
import LoadingSpinner from "@/components/LoadingSpinner";
import store from "@/store";
import { jwtDecode } from "jwt-decode";
import { toast } from "vue3-toastify";
import vueRecaptcha from "vue3-recaptcha2";
import ModalView from "@/components/ModalView";
import ClosedEye from "@/components/icons/closed-eye.vue";
import OpenedEye from "@/components/icons/opened-eye.vue";
import Headphone from "@/components/icons/headphone-icon.vue";
import Planet from "@/components/icons/planet-icon.vue";
import backgroundImg from "@/assets/images/loginnew.jpg";
export default {
  name: "UserLogin",
  components: {
    LoadingSpinner,
    vueRecaptcha,
    ModalView,
    ClosedEye,
    Planet,
    OpenedEye,
    Headphone,
  },
  beforeMount() {
    const token = localStorage.getItem("auth-token");
    if (token) {
      this.$router.push("/");
    }
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.installEvent = e;
      this.installBtnShown = true;
    });
    const rememberMe = localStorage.getItem("remember-me");
    if (rememberMe) {
      this.rememberMe = rememberMe;
      this.name = localStorage.getItem("username");
      this.password = localStorage.getItem("password");
    }
  },
  data() {
    return {
      name: "",
      password: "",
      nameError: "",
      passwordError: "",
      loading: false,
      isCreateNewPassword: false,
      backgroundImg: backgroundImg,
      newPassword: "",
      repeatNewPassword: "",
      newPasswordError: "",
      repeatNewPasswordError: "",
      rememberMe: false,
      resetPasswordEmail: "",
      resetPasswordEmailError: "",
      resetPasswordDialogVisible: false,
      passwordVisible: false,
      installBtnShown: false,
      captchaValid: false,
      captchaError: "",
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    recaptchaVerified(response) {
      this.captchaValid = true;
    },
    async login() {
      this.nameError = "";
      this.passwordError = "";
      this.captchaError = "";
      if (this.name === "") {
        this.nameError = "Пожалуйста, введите имя";
      }
      if (this.password.length < 3) {
        this.passwordError = "Пароль не может быть короче 3 символов";
      }
      if (this.captchaValid == false) {
        this.captchaError = "Каптча не пройдена";
      }
      if (this.password === "") {
        this.passwordError = "Пожалуйста, введите пароль";
      }
      if (
        this.nameError === "" &&
        this.passwordError === "" &&
        this.captchaError === ""
      ) {
        this.loading = true;
        try {
          const response = await http.post("/api/login_check", {
            username: this.name.trim(),
            password: this.password.trim(),
          });
          store.state.user = jwtDecode(response.data.token);
          store.state.token = response.data.token;
          localStorage.removeItem("username");
          localStorage.removeItem("password");
          if (store.state.user.isExit != 0) {
            localStorage.setItem("auth-token", response.data.token); // Сохраняем токен
            localStorage.setItem("remember-me", this.rememberMe);
            if (this.rememberMe) {
              localStorage.setItem("username", this.name.trim());
              localStorage.setItem("password", this.password.trim());
            }
            // Переадресация пользователя или обновление состояния аутентификации
            this.$router.push("/");
          } else {
            toast.success("Пожалуйста, создайте новый пароль!", {
              autoClose: 3000,
            });
            this.isCreateNewPassword = true;
          }
          this.loading = false;
        } catch (error) {
          this.loading = false;
        }
      }
    },
    async createNewPassword() {
      this.newPasswordError = "";
      this.repeatNewPasswordError = "";
      if (this.newPassword === "") {
        this.newPasswordError = "Пожалуйста, введите пароль";
      }
      if (this.newPassword !== "" && this.newPassword.length < 3) {
        this.newPasswordError = "Пароль не может быть короче 3 символов";
      }
      if (this.repeatNewPassword === "") {
        this.repeatNewPasswordError = "Пожалуйста, введите пароль";
      }
      if (this.repeatNewPassword !== "" && this.repeatNewPassword.length < 3) {
        this.repeatNewPasswordError = "Пароль не может быть короче 3 символов";
      }
      if (
        this.repeatNewPassword !== "" &&
        this.repeatNewPassword.length >= 3 &&
        this.newPassword !== this.repeatNewPassword
      ) {
        this.repeatNewPasswordError = "Пароли должны совпадать";
      }
      if (this.newPasswordError === "" && this.repeatNewPasswordError === "") {
        this.loading = true;
        try {
          localStorage.setItem("auth-token", store.state.token); // Сохраняем токен
          await http.put(`/api/user/update/${store.state.user.id}`, {
            isExit: 1,
            password: this.repeatNewPassword,
          });
          store.state.user.isExit = 1;
          // Переадресация пользователя
          this.$router.push("/");
          this.loading = false;
        } catch (error) {
          localStorage.removeItem("auth-token");
          this.loading = false;
        }
      }
    },
    async resetPassword() {
      this.resetPasswordEmailError = "";
      if (this.resetPasswordEmail === "") {
        this.resetPasswordEmailError = "Пожалуйста, введите e-mail";
      }
      if (this.resetPasswordEmailError === "") {
        this.loading = true;
        try {
          var response = await http.post(
            `/api/user/reset-password/${this.resetPasswordEmail.trim()}`
          );
          if (response.data !== null && response.status === 200) {
            toast.success(
              "Пароль успешно сброшен! \nДанные для входа отправлены на e-mail",
              {
                autoClose: 5000,
              }
            );
            this.resetPasswordDialogVisible = false;
            this.loading = false;
          }
        } catch (error) {
          this.loading = false;
        }
      }
    },
    changePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    installPWA() {
      this.installEvent.prompt();
      this.installEvent.userChoice.then((choice) => {
        if (choice.outcome === "accepted") {
          // Do something additional if the user chose to install
          this.installBtnShown = false;
        } else {
          // Do something additional if the user declined
        }
      });
    },
  },
  computed: {
    backgroundImageStyle() {
      return {
        backgroundImage: `url(${this.backgroundImg})`,
      };
    },
  },
  mounted() {
    const googleSignInScript = document.createElement("script");
    googleSignInScript.setAttribute(
      "src",
      "https://www.google.com/recaptcha/api.js?render=explicit"
    );
    googleSignInScript.setAttribute("async", "true");
    googleSignInScript.setAttribute("defer", "true");
    document.head.appendChild(googleSignInScript);
  },
};
</script>

<style scoped>
.spin {
  z-index: 1001;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
font-face {
  font-family: "text-security-disc";
  src: url("data:font/truetype;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMg8SBiUAAAC8AAAAYGNtYXAXVtKJAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5ZisAzZUAAAF4AAAA2GhlYWQHZLTFAAACUAAAADZoaGVhB8IDxwAAApAAAAAkaG10eA4AAAAAAKy0AAAAHGxvY2EAKABOAAAq3AAAABBtYXhwAAgADAAACswAAAAgbmFtZVcZpu4AAArsAAABRXBvc3QAAwAAAAACNAAAACAAAwMAAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADpAQPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6QH//f//AAAAAAAg6QH//f//AAH/4xcDAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAAB//8AAAQAAsAAJgAAATIXHgEXFhUUBw4BBwYjIicuAScmNSc0Nz4BNzYzMhceARcWFSc0NgIANS8uRhQUFBRGLi81NS8uRhQUAQgIYUVGUFBFRmEICQEwMALAFBRGLi81NS8uRhQUFBRGLi81AVBFRmEICQkIYUVGUAEwMA==");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "text-security-asterisk";
  src: url("data:font/truetype;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMg8SBhUAAAC8AAAAYGNtYXAXVtKJAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5ZiGILQ0AAAF4AAABFGhlYWQHVwCxAAACjAAAADZoaGVhB8IDxwAAAsgAAAAkaG10eA4AAN8AAALsAAAAHGxvY2EAKgBOAAADCAAAABBtYXhwAAgADAAAAxgAAAAgbmFtZVcZpu4AAAMwAAABRXBvc3QAAwAAAAAEeAAAACAAAwMAAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADpAQPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6QH//f//AAAAAAAg6QH//f//AAH/4xcDAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAAB//8AAAQAAsAAJgAAATIXHgEXFhUUBw4BBwYjIicuAScmNSc0Nz4BNzYzMhceARcWFSc0NgIANS8uRhQUFBRGLi81NS8uRhQUAQgIYUVGUFBFRmEICQEwMALAFBRGLi81NS8uRhQUFBRGLi81AVBFRmEICQkIYUVGUAEwMA==");
  font-weight: normal;
  font-style: normal;
}

.component-block.user-login-page .block-container {
  min-height: 100vh;
}
.block-title {
  line-height: 1.2;
  font-size: 24px;
  color: #4d5460;
  font-weight: 600;
  font-family: "Open Sans", sans-serif !important;
  margin-bottom: 16px;
  text-align: center;
}

.spin {
  z-index: 1001;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-container {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Open Sans", sans-serif !important;
  font-weight: 400;
  background: white;
  overflow: hidden;
}
.recaptcha-container {
  display: flex;
  justify-content: center;
  width: 400px;
  margin: 0 auto;
}

/* Для мобильных устройств */
@media screen and (max-width: 1023px) {
  .recaptcha-container {
    width: 100%;
  }
}
.login-container {
  width: 50%;
  display: flex;
  align-items: center;
  flex-direction: column;
  max-height: 100vh;
  overflow: auto;
  padding: 30px 0;
}

.floating-label-input input:-webkit-autofill,
.floating-label-input input:-webkit-autofill:hover,
.floating-label-input input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 30px rgba(228, 234, 242, 1) inset !important;
  -webkit-text-fill-color: #4d5460 !important;
  transition: background-color 5000s ease-in-out 0s;
}

/* Force the label to be small when autofilled */
.floating-label-input input:-webkit-autofill + label {
  top: 14px;
  font-size: 14px;
  color: rgba(77, 84, 96, 1);
}

/* Firefox autofill styles */
.floating-label-input input:autofill {
  background-color: rgba(228, 234, 242, 1) !important;
  color: #4d5460 !important;
}

.floating-label-input input:autofill + label {
  top: 14px;
  font-size: 14px;
  color: rgba(77, 84, 96, 1);
}

.floating-label-input input[type="password"] {
  font-size: 14px;
  letter-spacing: 1px;
  -webkit-text-security: disc;
  text-security: disc;
  font-family: "text-security-disc", sans-serif !important;
}

/* Добавляем стиль для маскировки пароля через CSS */
.floating-label-input input[type="password"]::placeholder {
  color: transparent;
}

/* Стиль для видимого пароля */
.floating-label-input input[type="text"] {
  font-family: "Open Sans", sans-serif !important;
  letter-spacing: normal;
  font-size: 14px;
}

.button-reset {
  width: 100%;
  height: 38px;
  background: #005291;
  color: #ffffff;
  border: 0;
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.4s;
}

.button-reset:active {
  transform: scale(0.95);
}

/* Make sure the has-value class is applied when autofilled */
.floating-label-input input:-webkit-autofill,
.floating-label-input input:autofill {
  padding: 21px 16px 10px 48px !important;
}

/* Ensure the label is positioned correctly when autofilled */
.floating-label-input input:-webkit-autofill + label,
.floating-label-input input:autofill + label {
  top: 14px;
  font-size: 14px;
  color: rgba(77, 84, 96, 1);
}

.error-message {
  color: #eb5e5e;
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  margin-top: 8px;
  text-align: left;
}

.floating-label-input {
  position: relative;
  width: 400px;
  height: 56px;
}

.floating-label-input input {
  width: 100%;
  height: 100%;
  padding: 18px 16px 18px 48px;
  border: none;
  border-radius: 6px;
  background: rgba(228, 234, 242, 1);
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  color: #4d5460;
  outline: none;
  transition: all 0.3s ease;
}

.floating-label-input.has-value input {
  padding: 21px 16px 10px 48px; /* Padding при наличии значения */
}

.floating-label-input label {
  position: absolute;
  left: 48px;
  top: 45%;
  transform: translateY(-45%);
  font-size: 14px;
  font-family: "Open Sans", sans-serif !important;
  opacity: 0.7;
  color: #4d5460;
  pointer-events: none;
  transition: all 0.3s ease;
}

.error-input input {
  border: 1px solid #eb5e5e;
}
.error-input-with-margin {
  margin-bottom: 16px;
}
.floating-label-input input:focus + label,
.floating-label-input input:not(:placeholder-shown) + label,
.floating-label-input.has-value label {
  top: 14px;
  font-size: 14px;
  color: rgba(77, 84, 96, 1);
}

.floating-label-input .password-visibility {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

.floating-label-input::before {
  content: "";
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  background-image: url("../assets/images/Lock.svg");
  background-size: contain;
  background-repeat: no-repeat;
}

.email-input::before {
  content: "";
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  background-image: url("../assets/images/UserLogin.svg");
  background-size: contain;
  background-repeat: no-repeat;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.logo {
  display: block;
  margin: 0 auto 31px;
  max-width: 138px;
}

.login-link_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}

.pwa {
  width: 400px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 6px;
  color: #4d5460;
  height: 56px;
  padding: 17px;
  border: 1px solid #dde5ed;
}

.remember-me {
  font-family: "Open Sans", sans-serif !important;
  font-weight: 400;
  font-size: 14px;
  color: #4d5460;
  width: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
}

.remember-me-wrapper {
  display: flex;
  align-items: center;
}

.form-check-input {
  width: 20px;
  min-width: 20px;
  height: 20px;
  margin-right: 8px;
  appearance: none;
  background-image: url("../assets/images/system/ok.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.form-check-input:checked {
  background-color: #2c5697;
  border-color: #2c5697;
}

.remember-me label {
  width: 100%;
  font-family: "Open Sans", sans-serif !important;
  text-align: left;
  line-height: 18px;
}

.login-btn {
  font-family: "Open Sans", sans-serif !important;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  line-height: 18px;
  border-radius: 6px;
  padding: 16px;
  width: 400px;
  outline: none;
  cursor: pointer;
  border: none;
  background: #2c5697;
  transition: all 0.4s;
  height: 54px;
}

.in-touch {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 57px;
  height: 27px;
}

.in-touch-elem {
  width: 78px;
  height: 1px;
  background: #000000;
  opacity: 0.1;
}

.in-touch-text {
  font-size: 20px;
  font-family: "Open Sans", sans-serif !important;
  font-weight: 600;
  color: #4d5460;
  margin: 0 16px;
}

.login-link {
  display: flex;
  align-items: center;
  border-radius: 6px;
  justify-content: center;
  font-family: "Open Sans", sans-serif !important;
  font-weight: 600;
  font-size: 16px;
  color: #4d5460;
  width: 400px;
  padding: 16px;
  outline: none;
  border: 1px solid #dde5ed;
  background: transparent;
  text-decoration: none;
  transition: all 0.4s;
}

.login-link svg {
  margin-right: 12px;
  width: 24px;
  height: 24px;
}

.image-container {
  width: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.image-text {
  font-family: Acrom, sans-serif !important;
  font-size: 65px;
  line-height: 95%;
  color: rgba(255, 255, 255, 0.29);
  position: absolute;
  bottom: 13px;
  left: 35px;
  text-transform: uppercase;
  max-width: 800px;
  z-index: 1;
}

.reset-password-link {
  font-size: 14px;
  cursor: pointer;
  font-weight: 600;
  font-family: "Open Sans", sans-serif !important;
  line-height: 18px;
  color: #005291;
  text-decoration: none;
}
@media screen and (max-height: 768px) {
  .in-touch {
    margin-top: 37px;
  }
}

/* < 1200 */
@media screen and (max-width: 1199px) {
  .image-text {
    font-size: 55px;
  }
}

/* < 1024 */
@media screen and (max-width: 1023px) {
  .block-container {
    overflow: initial;
    min-height: 100vh;
  }

  .error-message {
    left: 50%;
  }

  .login-container {
    width: unset;
    text-align: center;
    display: block;
    max-height: unset;
    overflow: unset;
    max-width: 327px;
  }

  .login-link_wrapper {
    row-gap: 8px;
  }

  .floating-label-input {
    max-width: 327px;
    width: 100%;
  }

  .floating-label-input input {
    width: 100%;
    padding: 16px 16px 16px 48px;
    height: 52px;
  }

  .login-form {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .pwa {
    width: 100%;
    font-size: 14px;
    border-radius: 6px;
    height: 52px;
  }

  .login-link {
    width: 100%;
  }

  .in-touch {
    margin-bottom: 8px;
    margin-top: 32px;
    height: 22px;
  }

  .login-link {
    font-size: 14px;
    height: 52px;
  }

  .login-link svg {
    margin-right: 8px;
  }

  .in-touch-elem {
    width: 63px;
    height: 1px;
    background: #000000;
    opacity: 0.1;
  }

  .in-touch-text {
    font-size: 14px;
    font-family: "Open Sans", sans-serif;
    font-weight: 600;
    color: #4d5460;
    margin: 0 16px;
  }

  .image-container {
    display: none;
  }

  .remember-me {
    width: 100%;
    font-size: 12px;
    margin-bottom: 10px;
    overflow: hidden;
  }

  .reset-password-link {
    font-size: 12px;
  }

  .logo {
    width: 101px;
  }

  .block-title {
    font-size: 20px;
    margin-bottom: 12px;
  }

  .login-btn {
    width: 100%;
    font-size: 14px;
    height: 52px;
  }
}

/* < 425 */
@media screen and (max-width: 424px) {
  .in-touch-elem {
    width: 70px;
  }

  .error-message {
    font-size: 12px;
  }

  .block-container {
    padding: 0 15px;
  }
}
</style>
